export default {
  mediacategories: 'Catégories de média',
  mediacategory: 'Catégorie de média',
  verbose_mediacategory: 'une catégorie de media',
  select_mediacategories: 'Sélectionner une catégorie de média',
};
